import type { StepTypeKebabCase } from 'src/types/course/step';

/**
 * Step types that play another type's stack: True / False, Word Builder and
 * Memory Flip steps use a Vocabulary stack, so authors write no new content. The backend filter
 * endpoint keeps the same map (user-section controller STACK_KIND_OF).
 */
const STACK_KIND_OF: Partial<Record<StepTypeKebabCase, StepTypeKebabCase>> = {
  'true-false': 'vocabulary',
  'word-builder': 'vocabulary',
  'memory-flip': 'vocabulary',
};

/** The stack type a step type plays (its own type by default). */
export function stackKindOf(kind: StepTypeKebabCase): StepTypeKebabCase {
  return STACK_KIND_OF[kind] ?? kind;
}
